import React, { useState } from 'react';
import axios from 'axios';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';
import { LiaEyeSlashSolid, LiaEyeSolid } from 'react-icons/lia';
import { FaUserPlus, FaSpinner } from 'react-icons/fa';

const Register = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const formData = new FormData(e.target as HTMLFormElement);
    const nameVal = formData.get('name') || formData.get('username');
    if (nameVal) {
      formData.set('username', nameVal.toString());
      formData.set('name', nameVal.toString());
    }

    try {
      const response = await axios.post('https://rmbbackend.rmbjaipur.com/auth/register', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 201 || response.data.message) {
        alert('Registration submitted successfully! Please log in.');
        navigate('/login');
      }
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Registration failed. Please verify your details.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F0F4F8]">
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-10 sm:px-6 lg:px-8">
        <div className="w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-200">

          {/* Header */}
          <div className="bg-gradient-to-r from-[#0A2451] to-[#1E3A8A] p-8 text-center text-white">
            <div className="w-14 h-14 bg-[#FDBC12] rounded-full mx-auto flex items-center justify-center text-[#0A2451] shadow-lg mb-3">
              <FaUserPlus size={24} />
            </div>
            <h1 className="text-2xl font-black">Member Registration</h1>
            <p className="text-xs text-slate-300 mt-1">Join Rotary Means Business Jaipur Chapter</p>
          </div>

          {/* Form */}
          <div className="p-6 sm:p-8 space-y-6">
            {error && (
              <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-xl text-red-700 text-xs font-semibold">
                {error}
              </div>
            )}

            <form onSubmit={handleRegister} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Full Name (Username) *</label>
                <input type="text" name="name" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="e.g. Ramesh Kumar" required />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Email Address *</label>
                <input type="email" name="email" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="ramesh@company.com" required />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Date of Birth *</label>
                <input type="date" name="dob" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" required />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Mobile Number *</label>
                <input type="text" name="number" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="+91 98290 12345" required />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Company Name *</label>
                <input type="text" name="company_name" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="Acme Logistics Pvt Ltd" required />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Designation *</label>
                <input type="text" name="designation" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="Managing Director" required />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Company Address</label>
                <textarea name="company_address" rows={2} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="Office address..." />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Company Website</label>
                <input type="text" name="company_website" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="https://company.com" />
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Social Media Links</label>
                <input type="text" name="social" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="LinkedIn / Instagram URL" />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">About Your Business</label>
                <textarea name="about_company" rows={2} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="Describe your core products & services..." />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Payment Transfer Details *</label>
                <textarea name="payment_details" rows={2} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]" placeholder="Enter Transaction ID, Date, Bank Name, or UTR #" required />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Profile Photo</label>
                <input type="file" name="profile" accept="image/*" className="w-full bg-slate-50 border border-slate-200 rounded-xl p-2.5 text-xs text-slate-700 outline-none" />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Password *</label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 pr-11 text-sm font-semibold text-slate-900 outline-none focus:border-[#FDBC12]"
                    placeholder="Create a strong password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 transition"
                  >
                    {showPassword ? <LiaEyeSolid size={20} /> : <LiaEyeSlashSolid size={20} />}
                  </button>
                </div>
              </div>

              <div className="md:col-span-2 pt-3">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black rounded-xl text-sm shadow-xl transition flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50"
                >
                  {loading ? (
                    <>
                      <FaSpinner className="animate-spin" size={16} /> Submitting Application...
                    </>
                  ) : (
                    "Submit Member Application"
                  )}
                </button>

                <p className="text-xs text-slate-600 text-center mt-4">
                  Already have an account?{" "}
                  <a href="/login" className="font-bold text-[#0A2451] hover:text-[#FDBC12]">
                    Login here →
                  </a>
                </p>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Register;